import {
    useHomeContent,
    HomeContentProps,
} from '../../home-page/hooks/use-home-content';
import {
    DisclaimersService,
    DisclaimerContent,
} from '../../../services/disclaimers-service/disclaimers-service';
import {
    AemVideoQuietCardDetails,
    VideoQuietCardDetails,
} from '../../../models/experiencefragments/category-view';
import { useCxVideoquietcardOneContent } from './use-cx-videoquietcardone-content';
import { useCxVideoquietcardTwoContent } from './use-cx-videoquietcardtwo-content';

export function useProcessedCxContent(disclaimers: DisclaimerContent[]) {
    const homeContent = useHomeContent('learning-hub/landing-page');
    const cxVideoQuietCardOneContent = useCxVideoquietcardOneContent();
    const cxVideoQuietCardTwoContent = useCxVideoquietcardTwoContent();
    let processedHomeContent: HomeContentProps | null = null;
    let videoQuietCardOneDetails: VideoQuietCardDetails | null = null;
    let videoQuietCardTwoDetails: VideoQuietCardDetails | null = null;

    if (homeContent) {
        const [
            bannerFields,
            bannerDisclaimers,
        ] = DisclaimersService.processFieldsWithDisclaimers(
            ['bannerTitle', 'bannerDescription'],
            'bannerDisclaimer',
            disclaimers,
            homeContent
        );
        disclaimers = disclaimers.concat(bannerDisclaimers);
        const [
            vehicleSelectorFields,
            vehicleSelectorDisclaimers,
        ] = DisclaimersService.processFieldsWithDisclaimers(
            ['vehicleSelectorDescription'],
            'vehicleSelectorDisclaimer',
            disclaimers,
            homeContent
        );
        processedHomeContent = {
            ...homeContent,
            bannerTitle: bannerFields[0]!.plain,
            bannerTitleWithDisclaimer: bannerFields[0]?.node,
            bannerDescription: bannerFields[1]!.plain,
            bannerDescriptionWithDisclaimer: bannerFields[1]?.node,
            vehicleSelectorDescription: vehicleSelectorFields[0]!.plain,
            vehicleSelectorDescriptionWithDisclaimer:
                vehicleSelectorFields[0]?.node,
        };
        disclaimers = disclaimers.concat(vehicleSelectorDisclaimers);
    }

    if (cxVideoQuietCardOneContent) {
        const [
            processedVideoQuietCardOneDetails,
            processedDisclaimersOne,
        ] = DisclaimersService.processItemWithDisclaimers<
            AemVideoQuietCardDetails,
            VideoQuietCardDetails,
            keyof AemVideoQuietCardDetails
        >(
            ['title', 'description'],
            'disclaimer',
            disclaimers,
            cxVideoQuietCardOneContent,
            (item, fields) => {
                return {
                    ...item,
                    title: fields[0]?.node,
                    description: fields[1]?.node,
                };
            }
        );
        disclaimers = disclaimers.concat(processedDisclaimersOne);
        videoQuietCardOneDetails = processedVideoQuietCardOneDetails;
    }

    if (cxVideoQuietCardTwoContent) {
        const [
            processedVideoQuietCardTwoDetails,
            processedDisclaimersTwo,
        ] = DisclaimersService.processItemWithDisclaimers<
            AemVideoQuietCardDetails,
            VideoQuietCardDetails,
            keyof AemVideoQuietCardDetails
        >(
            ['title', 'description'],
            'disclaimer',
            disclaimers,
            cxVideoQuietCardTwoContent,
            (item, fields) => {
                return {
                    ...item,
                    title: fields[0]?.node,
                    description: fields[1]?.node,
                };
            }
        );
        disclaimers = disclaimers.concat(processedDisclaimersTwo);
        videoQuietCardTwoDetails = processedVideoQuietCardTwoDetails;
    }

    return {
        processedHomeContent: processedHomeContent,
        videoQuietCardOneDetails,
        videoQuietCardTwoDetails,
        processedDisclaimers: disclaimers,
    };
}
